<template>
  <v-speed-dial
      v-model="fab"
      :bottom="true"
      :right="true"
      transition="slide-y-reverse-transition"
      v-show="showButton"
  >
    <template v-slot:activator>
      <v-btn
          v-model="fab"
          color="success darken-1"
          dark
          fab
      >
        <v-icon v-if="fab">
          mdi-close
        </v-icon>
        <v-icon v-else>
          mdi-whatsapp
        </v-icon>
      </v-btn>
    </template>
    <v-btn
        v-for="(whatsappNumber, i) in whatsappNumbers"
        :key="i"
        fab
        dark
        small
        :color="whatsappNumber.color"
        :href="whatsappNumber.href"
    >
      <v-icon>mdi-whatsapp</v-icon>
    </v-btn>
  </v-speed-dial>
</template>

<script>
import {config} from '~/plugins/config'
import {mapState, mapGetters} from 'vuex'

export default {

  data() {
    return {
      fab: false,
    }
  },

  computed: {
    ...mapGetters({
      authenticated: 'auth/check',
    }),
    showBtn() {
      return true;
    },
    showButton() {
      return this.authenticated && [
        '/',
        '/user/account/deposits',
        '/user/account/withdrawals',
        '/support',
      ].includes(this.$route.path);
    },
    whatsappNumbers() {
      const colors = ['green', 'red', 'blue', 'green', 'red', 'blue']
      return (config('app.whatsapp_numbers') || []).map((number, i) => ({
        href: `https://wa.me/${number}?text=` + encodeURIComponent('Hola, Necesito Ayuda...'),
        number: number,
        color: colors[i]
      }))
    }
  }
}
</script>

<style lang="scss" scoped>
.v-speed-dial {
  position: fixed;
}
</style>
